export const getTokenLocal = () => {
    try {
        const requestHeader = localStorage.getItem('requestHeader');
        if (!requestHeader) {
            return '';
        }
        const requestHeaderObj = JSON.parse(requestHeader);
        return (requestHeaderObj === null || requestHeaderObj === void 0 ? void 0 : requestHeaderObj.TOKEN) || '';
    }
    catch (_a) {
        return '';
    }
};
